import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  DataService,
  PamlabApiServiceService,
  RouteService,
} from '@/shared/services';
import { map, Observable, startWith } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  Program,
  ProgramBottleneckCourseFilters,
} from '../../../../../server/types';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'program-bottleneck-form',
  templateUrl: './program-bottleneck-form.component.html',
  styleUrls: ['./program-bottleneck-form.component.css'],
  standalone: false,
})
export class ProgramBottleneckFormComponent implements OnInit {
  //variable for displaying form options based on colleges chosen
  public programOptions!: Observable<Program[]>;
  public filters: ProgramBottleneckCourseFilters = {
    colleges: [],
    programs: [],
    years: [],
    terms: [],
  };

  // killer courses form group
  public programBottleneckCoursesForm = new FormGroup({
    college: new FormControl('Hal Marcus College of Science and Engineering', [
      Validators.required,
    ]),
    program: new FormControl('Mechanical Engineering', [Validators.required]),
    year: new FormControl('UWFYear2', [Validators.required]),
    term: new FormControl('Fall', [Validators.required]),
  });
  public filterLoading = false;

  constructor(
    private _dialog: MatDialog,
    private _apiService: PamlabApiServiceService,
    private _dataService: DataService,
    private _routeService: RouteService,
  ) {}

  ngOnInit(): void {
    this.filterLoading = true;
    this._apiService.fetchProgramBottleneckFilters().subscribe({
      next: (filters) => {
        this.filters = filters;
        this.programOptions = this.programBottleneckCoursesForm
          .get('program')!
          .valueChanges.pipe(
            startWith(''),
            map((value) => this._filter(value || '')),
          );
        this.filterLoading = false;
        this.programBottleneckFormSubmit();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  // killerCoursesForm get data from api by passing user input from form
  programBottleneckFormSubmit() {
    this._dataService.setPendingData(true);

    // calling _apiService to get killer courses based on form inputs.
    this._apiService
      .getProgramBottleneck({
        college: this.programBottleneckCoursesForm.value.college!,
        program: this.programBottleneckCoursesForm.value.program!,
        year: this.programBottleneckCoursesForm.value.year!,
        term: this.programBottleneckCoursesForm.value.term!,
      })
      .subscribe({
        next: (data) => {
          this._dataService.setData({ data });
          this._dataService.setPendingData(false);
        },
        error: (errorRes: HttpErrorResponse) => {
          if (errorRes.status === 401) {
            this._routeService.navigate(environment['login_url']);
          }
          this._dataService.setData({ error: errorRes.error });
          this._dataService.setPendingData(false);
        },
      });
  }

  onCollegeChange() {
    // Reset the item control when college changes
    const college = this.programBottleneckCoursesForm.get('college')!.value;
    const selectedProgram = this.filters.programs
      .filter((x) => x.college === college)
      .sort((a, b) => a.name.localeCompare(b.name))[0];
    this.programBottleneckCoursesForm
      .get('program')!
      .setValue(selectedProgram.name);

    this.programOptions = this.programBottleneckCoursesForm
      .get('program')!
      .valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value || '')),
      );
  }

  // close popup _dialog after form is submitted
  closeDialog() {
    this._dialog.closeAll();
  }

  private _filter(value: string): Program[] {
    const filterValue = value.toLowerCase();
    const college = this.programBottleneckCoursesForm.get('college')!.value;
    const programs: Program[] = this.filters.programs.filter(
      (x) => x.college === college,
    );

    return programs
      .filter((program: Program) =>
        program.name.toLowerCase().includes(filterValue),
      )
      .sort((a, b) => a.name.localeCompare(b.name));
  }
}
